import { render, staticRenderFns } from "./TermOfAddressField.vue?vue&type=template&id=ec94982e&"
import script from "./TermOfAddressField.vue?vue&type=script&lang=ts&"
export * from "./TermOfAddressField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports